import React from 'react';
import { Download, Loader2 } from 'lucide-react';
import IconButton from './IconButton';

interface DocumentCardRow {
    label: string;
    value: string;
    showDownload?: boolean;
}

interface DocumentCardProps {
    title: string;
    description?: string;
    rows: DocumentCardRow[];
    onDownload?: () => void;
    downloadLabel?: string;
    preview?: React.ReactNode;
    hideDownload?: boolean;
    isLoading?: boolean;
}

const DocumentCard: React.FC<DocumentCardProps> = ({
    title,
    description,
    rows,
    onDownload,
    downloadLabel = 'Download Certificate',
    preview,
    hideDownload = false,
    isLoading = false
}) => {
    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 shadow-sm">
            <div className="space-y-3">
                {/* Header with title and download button */}
                <div className="flex justify-between items-center">
                    <div className="flex-1">
                        <h3 className="font-semibold text-gray-900 dark:text-white">
                            {title}
                        </h3>
                        {description && (
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                {description}
                            </p>
                        )}
                    </div>

                    {!hideDownload && onDownload && (
                        <div className="ml-4">
                            <IconButton
                                label={downloadLabel}
                                color="green"
                                icon={isLoading ? <Loader2 className="animate-spin" /> : <Download />}
                                onClick={onDownload}
                                disabled={isLoading}
                            />
                        </div>
                    )}
                </div>



                {/* Label-value pairs */}
                <div className="text-sm space-y-1">
                    {rows.map((row, index) => (
                        <div key={index}>
                            {row.label && row.value && (
                                <p className="text-gray-600 dark:text-gray-400">
                                    <span className="font-medium">{row.label}:</span>{' '}
                                    {row.value}
                                </p>
                            )}
                        </div>
                    ))}
                </div>

                {/* PDF Preview if provided */}
                {preview && (
                    <div className="w-full">
                        {preview}
                    </div>
                )}

            </div>
        </div>
    );
};

export default DocumentCard;